import React from "react";
import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Navbar } from "./Navbar";
import "../Style.css";
import "../../Util.css";
import PoweredBy from "./common_powered_by";

export const Layout = () => {
  return (
    <div className="d-flex flex-column flex-xl-row" style={{ height: "100vh", overflow: "hidden" }}>
      <Sidebar />
      <div className="w-100 bg-half-white d-flex flex-column" style={{ height: "100vh" }}>
        <Navbar />
        <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
          <Outlet />
        </div>
        
      </div>
    </div>
  );
};

export default Layout;
